import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export class CustomValidators {

  static oneDigitOrSpecialChar(control: AbstractControl): ValidationErrors {
    if (CustomValidators.oneDigit(control) !== null && CustomValidators.oneSpecialChar(control) !== null)  {
      return { oneDigitOrSpecialChar: true };
    }
    return null;
  }

  static oneDigit(control: AbstractControl): ValidationErrors {
    const regex = /\d/;
    const isValid = regex.test(control.value);

    if (control.value.length > 0) {
      return isValid ? null : { oneDigit: true };
    }

    return null;
  }

  static oneUppercase(control: AbstractControl): ValidationErrors {
    const regex = /[A-Z]/;
    const isValid = regex.test(control.value);

    if (control.value.length > 0) {
      return isValid ? null : { oneUppercase: true };
    }

    return null;
  }

  static oneSpecialChar(control: AbstractControl): ValidationErrors {
    const regex = /[^a-zA-Z0-9]/;
    const isValid = regex.test(control.value);

    if (control.value.length > 0) {
      return isValid ? null : { oneSpecialChar: true };
    }

    return null;
  }

  static passwordMatch(form: FormGroup): ValidationErrors {
    const pw1 = form.get('newPassword');
    const pw2 = form.get('confirmPassword');

    if (pw1 != null && pw2 != null && pw1.value !== pw2.value) {
      return { passwordMatch: true };
    }

    return null;
  }
}
